import { useState, useEffect } from "react";
import * as APIModels from "../../../../models";
import {
    SubmissionService,
    DocumentService,
} from "../../../../services/SubmissionService";
import CaseSearch from "../CaseSearch";
import Pleadings from "../Pleadings";
import Fees from "../Fees";

import { useParams } from "react-router-dom";

interface QueryParams {
    submissionId?: string;
    attorneyId?: string;
    filter?: string;
    state?: string;
}

export default function DFS({
    submission,
    filter,
}: {
    submission: APIModels.Submission;
    filter?: string;
}) {
    const [completedSubmission, setCompletedSubmission] = useState(submission);
    const [plaintiff, setPlaintiff] = useState(new APIModels.Party());
    const [submitting, setSubmitting] = useState(false);
    const [summonsText, setSummonsText] = useState("");

    const params: QueryParams = useParams<{
        submissionId?: string;
        attorneyId?: string;
        filter?: string;
        state?: string;
    }>();

    useEffect(() => {
        setCompletedSubmission(submission);

        const summons = submission.documents?.filter(
            (v) => v!.filename!.toLowerCase().indexOf("dfs_summons") > -1
        );

        if (summons && summons.length > 0) {
            DocumentService.getPageText({
                documentId: summons[0].id ?? "",
                pageNumber: 1,
            }).then(
                (resp) => {
                    console.log(resp);
                    if (resp.data && resp.data) {
                        setSummonsText(resp.data);
                    }
                },
                (error) => {
                    setSubmitting(false);
                    window.location.href = "/queue" + filter;
                }
            );
        }
    }, [submission]);

    const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        setSubmitting(true);
        SubmissionService.submitDFS({
            attorneyId: completedSubmission.attorneyID,
            filter: filter,
            state: completedSubmission.portalIdentifier,
            body: {
                ...completedSubmission,
                parties: [plaintiff],
            },
        }).then(
            (resp) => {
                console.log(resp);
                if (resp.data && resp.data.id) {
                    //show efile success
                    //setNextSubmission(resp.data);
                    window.location.href = `/efile?submissionId=${resp.data.id}&filter=${filter}`;
                } else {
                    //TODO: Show error
                    window.location.href = "/queue/" + filter;
                }
            },
            (error) => {
                setSubmitting(false);
                window.location.href = "/queue/" + filter;
            }
        );
        e.preventDefault();
    };

    return (
        <>
            <form className="needs-validation" onSubmit={onSubmit}>
                <div className="row">
                    <div className="col-sm-18 mb-3">
                        <label htmlFor="txtplaintiff" className="form-label">
                            Plaintiff
                        </label>
                        <div className="input-group">
                            <textarea
                                rows={5}
                                className="form-control"
                                id="txtplaintiff"
                                placeholder="Plaintiff"
                                aria-describedby="inputGroupPrepend"
                                value={plaintiff.name}
                                onChange={(event) =>
                                    setPlaintiff({
                                        ...plaintiff,
                                        name: event.currentTarget.value,
                                    })
                                }
                                required
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12" style={{ textAlign: "center" }}>
                        {submitting ? (
                            <button
                                className="btn btn-primary"
                                type="button"
                                disabled={true}
                            >
                                <span
                                    className="spinner-border spinner-border-sm me-1"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                                Submitting...
                            </button>
                        ) : (
                            <button className="btn btn-primary" type="submit">
                                Save
                            </button>
                        )}
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12 mb-3">
                        <label htmlFor="txtSummonsText" className="form-label">
                            Summons Text
                        </label>
                        <div className="input-group">
                            <textarea
                                style={{ width: "100%", height: "700px" }}
                                className="form-control"
                                id="txtSummonsText"
                                defaultValue={summonsText}
                            />
                        </div>
                    </div>
                </div>
            </form>
        </>
    );
}
